export const API_PATH_ApiDeviceMgmtRegionsGet = '/services/devices-mgtm/apiDeviceMgmtRegionsGet';
